
import Vue from 'vue';
import MenuOrBottomSheet from '@/components/base/MenuOrBottomSheet.vue';
import ComplexBackgroundBaseStyledMenu from '@/components/designElements/ComplexBackgroundBaseStyledMenu.vue';
import EnterpriseUpsellBadge from '@/components/EnterpriseUpsellWrapper/EnterpriseUpsellBadge.vue';

export default Vue.extend({
	name: 'BaseStyledMenu',
	props: {
		value: { type: [Object, Number, String, Array], default: null },
		/**
		 * Example:
		 *
		 * [
		 * 	{
		 * 	  id: 1,
		 * 	  icon: 'mdi-plus'
		 * 	  label: 'Item 1',
		 * 	  description: 'Item 1 description',
		 * 	  value: 10,
		 *    disabled: true,
		 *    isRatio?: true,
		 *    isUpsell?: true,
		 * 	},
		 * 	{
		 * 	  id: 2,
		 * 	  icon: 'mdi-plus'
		 *    iconStyle: {'color': 'var(--red-800)'} // colors the icon + title; cascades to description unless descriptionStyle is set
		 *    descriptionStyle: {'color': 'var(--grey-400)'} // optional: override description color independently (e.g. keep grey while icon/title are red)
		 * 	  label: 'Item 2',
		 * 	  description: 'Item 2 description',
		 * 	  value: 20,
		 *    isRatio?: true,
		 *    isUpsell?: true,
		 * 	}
		 * ]
		 */
		isOpen: { type: Boolean, default: false }, // Control externally
		menuItems: { type: Array, default: () => [] },
		disabledText: { type: String, default: '(disabled)' },
		openOnHover: { type: Boolean, default: false },
		menuWidth: { type: String, default: '318px' },
		itemsAlwaysWhite: { type: Boolean, default: false },
		iconsOnly: { type: Boolean, default: false },
		horizontalMenu: { type: Boolean, default: false },
		closeOnClick: { type: Boolean, default: true },
		bottomSheetPersistent: { type: Boolean, default: false },
		nudgeBottom: { type: Number, default: 50 },
		closeDelay: { type: Number, default: 300 },
	},
	data () {
		return {
			localIsOpen: false,
		};
	},
	watch: {
		isOpen: {
			immediate: true,
			handler (newVal: boolean, oldVal: boolean) {
				if (newVal !== oldVal) {
					this.localIsOpen = !!newVal;
				}
			},
		},
		localIsOpen: {
			immediate: true,
			handler (newVal: boolean, oldVal: boolean) {
				if (newVal !== oldVal && newVal !== this.isOpen) {
					// Sync with external control
					this.$emit('is-open-input', !!newVal);
				}
			},
		},
	},
	methods: {
		onMenuItemSelect (value: any, close) {
			this.$emit('input', value);
			if (close) {
				close();
			}
		},
	},
	components: {
		EnterpriseUpsellBadge,
		MenuOrBottomSheet,
		ComplexBackgroundBaseStyledMenu,
	},
});
